/* eslint-disable max-len */
import { useEffect } from 'react';
import { type StandardApplicationEntrypointContextDataFragment } from '../../../../api/fragments/StandardApplicationEntrypointContextData';
import { type StandardApplicationPublicAccessEntrypointContextDataFragment } from '../../../../api/fragments/StandardApplicationPublicAccessEntrypointContextData';
import { useDealerContext, useSingleDealerId } from '../../../../components/contexts/DealerContextManager';
import PortalLoadingElement from '../../../../components/PortalLoadingElement';
import NotFoundResult from '../../../../components/results/NotFoundResult';
import useTranslatedString from '../../../../utilities/useTranslatedString';
import useApplyNewApplication from './applyNew/useApplyNewApplication';
import CalculatorStage, { type CalculatorStageProps } from './CalculatorStage';

export type CarDetailPageProps = {
    endpoint:
        | StandardApplicationEntrypointContextDataFragment
        | StandardApplicationPublicAccessEntrypointContextDataFragment;
};

// todo later switch with comparison will be done here
const CarDetailPage = ({ endpoint }: CarDetailPageProps) => {
    // for apply new function to get application info
    const [hasToken, isValid, applyNewApplication] = useApplyNewApplication(endpoint);
    const { dealerId } = useSingleDealerId();
    const { dealersFromApi, setAllVisible, setDealerOptions } = useDealerContext();
    const translated = useTranslatedString();

    useEffect(() => {
        if (dealersFromApi.length > 0) {
            const dealerOption = dealersFromApi.map(dealer => ({
                value: dealer.id,
                label: translated(dealer.legalName),
            }));
            setDealerOptions(dealerOption);
        }
        setAllVisible();
    }, []);

    // from apply new application but not valid (maybe token expired)
    if (hasToken && !isValid) {
        return <NotFoundResult />;
    }

    if (hasToken && !applyNewApplication) {
        return <PortalLoadingElement />;
    }

    return (
        <CalculatorStage
            application={applyNewApplication as CalculatorStageProps['application']}
            dealerIds={[dealerId]}
            endpoint={endpoint}
        />
    );
};

export default CarDetailPage;
